module.exports = __webpack_public_path__ + "img/location_off.04b920d2.svg";